import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal, Button } from "react-bootstrap";
import styled from "styled-components";
import axios from "axios";
import {
  faEye,
  faPen,
  faPlus,
  faTimes,
  faFileExcel,
  faUndo,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
//import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
//import styles from "../../masters/master.css";
import apiUrl from "../apiUrlConstant";
//import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import Select from "react-select";
import * as Yup from "yup";
import { getUserType, fileUploadPath } from "../utils/index";
import { PopupMessage } from "../utils/utils";
import Popup from "reactjs-popup";
//import { Chart } from "react-google-charts";
import SimpleReactValidator from "simple-react-validator";
import {
  Chart as ChartJS,
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar } from "react-chartjs-2";
import { Chart } from "react-google-charts";
import { counter } from "@fortawesome/fontawesome-svg-core";
ChartJS.register(
  LineController,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const labels = [
  "Expiring in 3 Months",
  "Expiring in 6 Months",
  "Expiring in 9 Months",
  "Expiring in 12 Months",
  "Expiring in over 12 Months",
];

const Checkbox = ({
  id,
  type,
  name,
  handleClick,
  isChecked,
  attr,
  occupierId,
  netAmt,
  invoiceId,
  amtBeforeTax
}) => {
  return (
    <input
      id={id}
      name={name}
      type={type}
      onChange={handleClick}
      checked={isChecked}
      data-attr={attr}
      data-occupierId={occupierId}
      data-netAmt={netAmt}
      data-invoiceId={invoiceId}
      data-amtBeforeTax={amtBeforeTax}
    />
  );
};
const TextField = styled.input`
  height: 32px;
  width: 200px;
  border-radius: 3px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: 1px solid #e5e5e5;
  padding: 0 32px 0 16px;

  &:hover {
    cursor: pointer;
  }
`;

const ClearButton = styled.button`
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  columns={columns}
  height: 34px;
  width: 32px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color:#003970;
`;

//['January', 'February', 'March', 'April', 'May', 'June', 'July'];
if (getUserType() == "Landlord") {
  var reportFilterForm = Yup.object().shape({
    // assetId: Yup.string().required("Required"),
    //stateId: Yup.string().required("Required"),
    //districtId: Yup.string().required("Required"),
    //cityId: Yup.string().required("Required"),
  });
} else if (getUserType() == "Occupier") {
  var reportFilterForm = Yup.object().shape({
    // brandId: Yup.number().required("Required"),
    // stateId: Yup.string().required("Required"),
    // districtId: Yup.string().required("Required"),
    // cityId: Yup.string().required("Required"),
  });
} else {
  var reportFilterForm = Yup.object().shape({
    // countryId: Yup.string().required("Required"),
    // stateId: Yup.string().required("Required"),
    // districtId: Yup.string().required("Required"),
    // cityId: Yup.string().required("Required"),
  });
}

var reportFilterForm = Yup.object().shape({
  financialYearOne: Yup.string().required("Required"),
  invoiceFrequency: Yup.string().required("Required"),
  chargeType: Yup.string().required("Required"),
  towerId: Yup.string().required("Required"),
  companyId: Yup.string().required("Required"),
});

let monthsArr = [];
var i = 0;
for (; i <= 12; i++) {
  monthsArr.push({ id: i, value: i });
}

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LeaseExpiryReport extends React.Component {
  groupId = { value: "" };
  state = {
    landloardArr: [],
    assetArr: [],
    subAssetArr: [],
    towerArr: [],
    companyArr: [],
    cityList: [],
    occupierList: [],
    landloardList: [],
    assetsList: [],
    tableTOShow: "RENT",
    companyDetails: {
      companyPan: "",
    },
    formResponseData: [],
    invoiceList: {},
    invoiceItemList: {},
    initialValues: {
      chargeTypeSelected: "",
      frequencySelected: "",
      chartType: "",
      landloardName: "",
      landloardId: "",
      subAssetName: "",
      subAssetId: "",
      companyName: "",
      companyId: "",
      towerId: "",
      cityName: "",
      cityId: "",
      occupierName: "",
      occupierId: "",
      companyPan: "",
      financialYearOne: "",
      invoiceFrequency: "",
      chargeType: "",
      hsn_sac: ""
    },
    countList: {
      generated: 0,
      draftCount: 0,
      approveCount: 0,
      applyCount: 0,
      cancelCount: 0,
    },
  };

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/brand/get-all-brands`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          brandList: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-lease-status`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log("data", data);
        this.setState({
          leaseStatus: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/lease-report/get-occupier-landloard`, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          landloardList: data.landloardList,
          //occupierList: data.occupierList,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    this.getAssetsList("", "", true);
  }

  componentDidUpdate() { }

  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({
        autoForceUpdate: this,
    });
    console.log(this.props, "this proopsss");
  }

  getAssetsList = (input, e, cust) => {
    if (
      (typeof e != "undefined" && e.action == "input-change") ||
      cust === true
    ) {
      fetch(
        `${apiUrl.apiUrl.url}/unit-detail/get-all-assets?city_id=` +
        this.state.initialValues.cityId +
        `&assetName=` +
        input,
        { headers }
      )
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          console.log("data", data);
          this.setState({
            assetsList: data,
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  formatDate = (date) => {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  handleCalenderOnBlur = () => {
    this.state.initialValues.financialYearOne = this.formatDate(
      this.state.financialYearOne
    );
    this.state.initialValues.financialYearTwo = this.formatDate(
      this.state.financialYearTwo
    );
    //this.state.initialValues.financialYearOne = date;
  };

  handleCalculation = (e, index, values) => {
    var total = 0;
    for (const value in values.amount) {
      total += parseInt(values.amount[value]);
    }
    //console.log(total, "total", this.state.formResponseData[index].variance )
    if (typeof index == "undefined") {
      this.setState({ totalInvoiceAmount: total });
    } else {
      var formData = this.state.formResponseData;
      formData[index].variance =
        parseFloat(formData[index].net_charge_amount) - e.target.value;

      this.setState({ totalInvoiceAmount: total, formResponseData: formData }); //, `formResponseData${}` : totalVariance
    }
  };

  valueChangeSubAsset = (newValue, actionMeta) => {
    this.state.initialValues.subAssetId = newValue.value;
    this.state.initialValues.subAssetName = newValue.label;
    this.setState({});
    fetch(`${apiUrl.apiUrl.url}/asset/sub-asset-towers?id=` + newValue.value, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          towerArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  valueFrequencyChange = (newValue, actionMeta) => {
    this.state.initialValues.frequencySelected = newValue.value;
    this.setState({});
  };
  valueChangeChargeType = (newValue, actionMeta) => {
    this.state.initialValues.chargeTypeSelected = newValue.value;
    this.state.initialValues.chargeType = newValue.value;
  };

  valueChangeCompany = (newValue, actionMeta) => {
    this.state.initialValues.companyId = newValue.value;
    this.state.initialValues.companyName = newValue.label;
    this.setState({});
    fetch(`${apiUrl.apiUrl.url}/landlord/get-company?id=` + newValue.value, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data.data, "ata");
        this.setState({
          companyDetails: data.data,
        });
        this.state.initialValues.companyPan = data.data.companyPan;
        this.setState({});
      })
      .catch((error) => {
        console.log(error);
      });
  };

  valueChangeAsset = (newValue, actionMeta) => {
    this.state.initialValues.assetId = newValue.value;
    this.state.initialValues.assetName = newValue.label;
    this.setState({});
    //landlord-group/fetch-landlord-list
    fetch(`${apiUrl.apiUrl.url}/asset/asset-sub-assets?id=` + newValue.value, {
      headers,
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          subAssetArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeChk = (val) => {
    console.log(val, "clickec");
  };

  valueChangeTower = (newValue, actionMeta) => {
    fetch(
      `${apiUrl.apiUrl.url}/landlord/get-group-companies?id=` +
      this.state.initialValues.groupId +
      `&tower=` +
      newValue.value,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          companyArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChangeLandlord = (newValue, actionMeta) => {
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});

    //landlord-group/fetch-landlord-list
    fetch(
      `${apiUrl.apiUrl.url}/asset/fetch-landlord-all-assets?id=` +
      newValue.value,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          assetArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(
      `${apiUrl.apiUrl.url}/landlord/get-group-companies?id=` + newValue.value,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          companyArr: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  processDebitItems = (status) => {
    var self = this;
    if (JSON.stringify(this.state.invoiceList) === JSON.stringify({})) {
      self.setState({
        messsagePopup: true,
        popupContent: "Please Select Item to proceed.",
      });
      return false;
    }
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/transaction/approve-debit`,
      data: { list: this.state.invoiceList, processType: status },
    }).then(function (response) {
      if (!response.data.success) {
        //actions.setSubmitting(false);
        //actions.setErrors(response.data);
      } else {
        self.setState({
          messsagePopup: true,
          popupContent: "Data Saved Successfully",
        });
        setTimeout(function () {
          self.state.formResponseData = [];
          self.state.invoiceList = {};
          self.setState({});
        });

        self.getInvoicesList(self.state.selectedStatus);
      }
    });
  };

  downlodFile = () => {
    var self = this;
    var prm = Object.entries(this.state.initialValues)
      .map(([key, val]) => `${key}=${val}`)
      .join("&");
    prm += "&requestType=" + this.state.selectedStatus;
    axios({
      method: "post",
      url:
        `${apiUrl.apiUrl.url}/sales-input/fetch-invoice-data?export=true&sendLink=true&` +
        prm,
      // data: columnsList,
    }).then(function (response) {
      window.location.href = `${apiUrl.apiUrl.url + "/lease-report/download-file?path=" + response.data
        }`;
    });
  };

  getInvoicesList = (status) => {
    var self = this;
    //this.state.initialValues.financialYearOne = this.state.financialYearOne;
    var prm = Object.entries(this.state.initialValues)
      .map(([key, val]) => `${key}=${val}`)
      .join("&");
    prm += "&requestType=" + status;
    var tableCounter,
      counter = 0;
    console.log(this.state.initialValues, "this.state.initialValues");

    var headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("TOKEN"),
    };
    fetch(
      `${apiUrl.apiUrl.url}/sales-input/fetch-invoice-data?` + prm,
      { headers }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        tableCounter = 0;
        this.setState({
          formResponseData: data.data,
          //invoiceOtherData: data.otherDetails,
          //countList: data.count,
        });

        if(status == "generate") {
          this.setState({countList: data.count});
        }

      })
      .catch((error) => {
        console.log(error);
      });
  };

  processInvoiceItems = (status) => {
    var self = this;
    if (JSON.stringify(this.state.invoiceItemList) === JSON.stringify({})) {
      self.setState({
        messsagePopup: true,
        popupContent: "Please Select Item to proceed.",
      });
      return false;
    }
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/transaction/process-invoice`,
      data: {
        list: this.state.invoiceList,
        processType: status,
        period: this.state.initialValues.financialYearOne,
        frequency: this.state.initialValues.frequencySelected,
      },
    }).then(function (response) {
      if (!response.data.success) {
        //actions.setSubmitting(false);
        //actions.setErrors(response.data);
      } else {
        self.setState({
          messsagePopup: true,
          popupContent: "Data Saved Successfully",
        });
        setTimeout(function () {
          self.state.formResponseData = [];
          self.state.invoiceList = {};
          self.state.invoiceItemList = {};
          self.setState({});
          //self.getInvoicesList(self.state.selectedStatus);
          self.getInvoicesList('generate');
        });
      }
    });
  };

  approveInvoice = () => {
    this.processInvoiceItems(1);
  };

  applyInvoice = () => {
    this.processInvoiceItems(2);
  };

  cancelInvoice = () => {
    this.processInvoiceItems(3);
  };

  rejectInvoice = () => {
    this.processInvoiceItems(0);
  };

  handleChangeClientGroup = (newValue, actionMeta) => {
    console.group("Value Changed", newValue, "actionmeta", actionMeta);
    this.state.initialValues.groupId = newValue.value;
    this.state.initialValues.groupName = newValue.label;
    this.setState({});
    console.log(newValue, "ddd");
    console.log(`action: ${actionMeta}`);
    console.groupEnd();
  };

  // handleSelectAll = e => {
  //   setIsCheckAll(!isCheckAll);
  //   setIsCheck(list.map(li => li.id));
  //   if (isCheckAll) {
  //     setIsCheck([]);
  //   }
  // };

  handleClick = (e) => {
    const { id, checked } = e.target;
    console.log("okok", id, checked, e.target.dataset, "str", e, "==");
    var invoiceListObj = this.state.invoiceList;
    var invoiceItemList = this.state.invoiceItemList;
    if (typeof invoiceListObj[id] == "undefined") {
      invoiceListObj[id] = {};
    }

    if (typeof invoiceListObj[id][[e.target.dataset.attr]] == "undefined") {
      invoiceListObj[id][[e.target.dataset.attr]] = {};
    }

    console.log(e.target.dataset, "e.target.dataset.netAmt");

    var uniqueKey =
      id + "-" + e.target.dataset.attr + "-" + e.target.dataset.occupierid;

    if (checked) {
      invoiceListObj[id][e.target.dataset.attr][e.target.dataset.occupierid] = {
        amt: e.target.dataset.netamt,
        invoiceId: e.target.dataset.invoiceid,
        amtBeforeTax: e.target.dataset.amtbeforetax
      };

      invoiceItemList[uniqueKey] = true;
    } else {
      delete invoiceListObj[id][e.target.dataset.attr][
        e.target.dataset.occupierid
      ];
      delete invoiceItemList[uniqueKey];
    }

    this.state.invoiceList = invoiceListObj;
    this.state.invoiceItemList = invoiceItemList;

    console.log(this.state.invoiceList, "final list", invoiceItemList);

    this.setState({});

    // this.setIsCheck([...isCheck, id]);
    // if (!checked) {
    //   this.setIsCheck(isCheck.filter(item => item !== id));
    // }
  };
  redirectAfterSave = () => {
    this.setState({
      messsagePopup: false,
      popupMessageContent: "",
    });
  };

  generateInvoice = () => {
    console.log(this.state.invoiceList, "ohh ");
    var self = this;

    if (JSON.stringify(this.state.invoiceItemList) === JSON.stringify({})) {
      self.setState({
        messsagePopup: true,
        popupContent: "Please Select Item to proceed.",
      });
      return false;
    }

    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/transaction/generate-invoice`,
      data: {
        list: this.state.invoiceList,
        companyId: this.state.initialValues.companyId,
        period: this.state.initialValues.financialYearOne,
        frequency: this.state.initialValues.frequencySelected,
        chargeType: this.state.initialValues.chargeTypeSelected,
        hsn_sac: this.state.initialValues.hsn_sac
      },
    }).then(function (response) {
      if (!response.data.success) {
        //actions.setSubmitting(false);
        //actions.setErrors(response.data);
      } else {
        self.setState({
          messsagePopup: true,
          popupContent: "Data Saved Successfully",
        });
        setTimeout(function () {
          self.state.formResponseData = [];
          self.getInvoicesList(self.state.selectedStatus);
          self.setState({});
        });
      }
    });
  };

  selectAll = () => this.selectAllCheckboxes(true);

  selectAllCheckboxes = (isSelected) => {
    Object.keys(this.state.formResponseData).forEach((checkbox) => {
      // BONUS: Can you explain why we pass updater function to setState instead of an object?
      this.setState((prevState) => ({
        checkboxes: {
          ...prevState.checkboxes,
          [checkbox]: isSelected,
        },
      }));

      this.state.formResponseData[checkbox][
        this.state.formResponseData[checkbox]["lease_id"]
      ] = isSelected;
    });
    this.setState({});
  };

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return <Redirect push to="/transactions/generate" />;
    }
    return (
      <div className="parentContainer">
        {this.renderForm()}
      </div>
    );
  }

  renderForm() {
    return (
      <>
        <div className="absoluteItemForTopBar">
          <div className="new_breadcrumbs_design">
            <ul className="d-flex align-items-center gap-3 p-0 m-0">
              <li>Invoicing</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>Transaction</li>
              <li><FontAwesomeIcon icon={faChevronRight} /></li>
              <li>
                <a href="#">Generate Invoicesss</a>
              </li>
            </ul>
          </div>
        </div>

        <Formik
          initialValues={this.state.initialValues}
          enableReinitialize
          // validationSchema={reportFilterForm}
          onReset={(values, actions) => {
            this.state.brandSelected = [];

            //this.state.chargeTypeSelected = '';
            //this.state.frequencySelected = '';
            //this.state.financialYearOne = '';
            //this.state.initialValues.towerId = '';

            for (const [key, value] of Object.entries(
              this.state.initialValues
            )) {
              this.state.initialValues[key] = "";
            }
            this.state.counter = Math.random();
            this.getInvoicesList("generate");
            this.state.redirect = true;
            this.setState({});
            //return <Redirect push to="/masters/client-profile" />;
          }}
          onSubmit={(values, actions) => {

            if (!this.validator.allValid()) {
              this.validator.getErrorMessages();
              this.validator.showMessages();
              //this.forceUpdate();
              return false;
            }

            this.setState({ selectedStatus: "generate" });
            this.getInvoicesList("generate");
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
          }) => (
            <>

              <div className="unitFormContainerNew">
                <Form autoComplete="off">
                  <div className="newGridSectionParent">
                    <div className="newGridSectionForFormMain">

                      <div className="newGridSectionInner">
                        <label>Landlord Group</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="landlordId"
                            isSearchable="true"
                            onChange={(e) => {
                              this.handleChangeLandlord(e);
                            }}
                            value={{
                              label: this.state.initialValues.groupName,
                              value: this.state.initialValues.groupId,
                            }}
                            options={this.state.landloardList.map((item) => ({
                              label: item.text,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="groupId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Landlord Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="assetName"
                            onChange={(e) => {
                              this.valueChangeAsset(e);
                            }}
                            value={{
                              label: this.state.initialValues.assetName,
                              value: this.state.initialValues.assetId,
                            }}
                            options={this.state.assetArr.map((item) => ({
                              label: item.asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="assetId" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Sub Asset Name</label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="subAssetName"
                            onChange={(e) => {
                              this.valueChangeSubAsset(e);
                            }}
                            value={{
                              label: this.state.initialValues.subAssetName,
                              value: this.state.initialValues.subAssetId,
                            }}
                            options={this.state.subAssetArr.map((item) => ({
                              label: item.sub_asset_name,
                              value: item.id,
                            }))}
                          />
                          <ErrorMessage name="subAssetName" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Tower Name<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="towerId"
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.state.initialValues.towerId = e.value;
                              this.valueChangeTower(e);
                            }}
                            options={this.state.towerArr.map((item) => ({
                              label: item.tower_name,
                              value: item.id,
                            }))}
                          />
                          {/* <ErrorMessage name="towerId" component="div" className="text-red" /> */}
                          {this.validator.message("Tower", this.state.initialValues.towerId, "required", { className: "text-danger" })}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Landlord Company Name<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="companyId"
                            onChange={(e) => {
                              this.valueChangeCompany(e);
                            }}
                            value={{
                              label: this.state.initialValues.companyName,
                              value: this.state.initialValues.companyId,
                            }}
                            options={this.state.companyArr.map((item) => ({
                              label: item.company_name,
                              value: item.id,
                            }))}
                          />
                          {this.validator.message("Landlord company name", this.state.initialValues.companyName, "required", { className: "text-danger" })}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Landlord Company PAN No.</label>
                        <div className="position-relative">
                          <Field
                            className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                            name="landloardCompanyPanNo"
                            value={this.state.initialValues.companyPan}
                          />
                          <ErrorMessage name="companyPan" component="div" className="text-red" />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Charge Type<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            onChange={(e) => {
                              this.valueChangeChargeType(e);
                            }}
                            value={this.state.chargeTypeSelected}
                            name="chargeType"
                            options={[
                              "RENT(Minimum Guarantee)",
                              "RENT(Revenue Share)",
                              "CAM",
                              "Property Tax",
                              "Marketing Fund Tax",
                              "Parking 2W",
                              "Parking 4W",
                              "Parking Other",
                              "Storage",
                              "Signage",
                            ].map((item) => ({
                              label: item,
                              value: item,
                            }))}
                          />
                          {this.validator.message("Charge type", this.state.initialValues.chargeType, "required", { className: "text-danger" })}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>HSN/SAC No.</label>
                        <div className="position-relative">
                          <Field
                            className="basic-single custom-select-style"
                              classNamePrefix="custom-select-style-inner"
                            name="hsn_sac"
                            onChange={(e) => {
                              this.state.initialValues.hsn_sac = e.target.value;
                              this.setState({})
                            }}
                            value={this.state.initialValues.hsn_sac}
                          />
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Invoice Frequency<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <Select
                            className="basic-single custom-select-style"
                            classNamePrefix="custom-select-style-inner"
                            name="invoiceFrequency"
                            onInputChange={this.handleChange}
                            onChange={(e) => {
                              this.state.initialValues.frequencySelected = e.value;
                              this.state.initialValues.invoiceFrequency = e.value;
                              this.setState({});
                            }}
                            value={this.state.frequencySelected}
                            options={["Monthly"].map((item) => ({
                              label: item,
                              value: item,
                            }))}
                          />
                          {this.validator.message("Charge type", this.state.initialValues.invoiceFrequency, "required", { className: "text-danger" })}
                        </div>
                      </div>

                      <div className="newGridSectionInner">
                        <label>Month<span className="astrik">*</span></label>
                        <div className="position-relative">
                          <DatePicker
                            onChange={(date) => this.setState({ financialYearOne: date })}
                            onBlur={this.handleCalenderOnBlur}
                            dateFormat="MMMM yyyy"
                            showMonthYearPicker
                            selected={this.state.financialYearOne}
                            onCalendarClose={this.handleCalenderOnBlur}
                          />
                          {this.validator.message("Charge type", this.state.financialYearOne, "required", { className: "text-danger" })}
                        </div>
                      </div>
                    </div>

                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                      <button type="submit" className="add_button">
                        Search
                      </button>
                      <button type="reset" className="reset_button">
                        Reset
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </>
          )}
        </Formik>

        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
        <Popup open={this.state.popupalertMessage} position="top center">
          {(close) => (
            <div>
              {this.state.popupMessageContent}
              <a className="close" onClick={this.redirectToClose}>
                &times;
              </a>
            </div>
          )}
        </Popup>

        <div className="transactionInvioceTabs">
          <div
            className={
              this.state.selectedStatus == "generate"
                ? "transactionInvioceInner active"
                : "transactionInvioceInner"
            }
            onClick={(e) => {
              this.setState({
                selectedStatus: "generate",
                randomNum: Math.random(),
              });

              this.getInvoicesList("generate");
            }}
          >
            <h5>Generated Invoices <b>({this.state.countList.generated})</b></h5>
          </div>

          <div
            className={
              this.state.selectedStatus == "draft"
                ? "transactionInvioceInner active"
                : "transactionInvioceInner"
            }
            onClick={(e) => {
              this.setState({
                selectedStatus: "draft",
                randomNum: Math.random(),
              });

              this.getInvoicesList("draft");
            }}
          >
            <h5>Draft Invoices <b>({this.state.countList.draftCount})</b> </h5>
          </div>
          <div
            className={
              this.state.selectedStatus === "approve"
                ? "transactionInvioceInner active"
                : "transactionInvioceInner"
            }
            onClick={(e) => {
              this.setState({
                selectedStatus: "approve",
                randomNum: Math.random(),
              });
              this.getInvoicesList("approve");
            }}
          >
            <h5>Approved Invoices <b>({this.state.countList.approveCount})</b></h5>
          </div>

          <div
            className={
              this.state.selectedStatus === "apply"
                ? "transactionInvioceInner active"
                : "transactionInvioceInner"
            }
            onClick={(e) => {
              this.setState({
                selectedStatus: "apply",
                randomNum: Math.random(),
              });

              this.getInvoicesList("apply");
            }}
          >
            <h5>Applied Invoices <b>({this.state.countList.applyCount})</b></h5>
          </div>

          <div
            className={
              this.state.selectedStatus === "cancel"
                ? "transactionInvioceInner active"
                : "transactionInvioceInner"
            }
            onClick={(e) => {
              this.setState({
                selectedStatus: "cancel",
                randomNum: Math.random(),
              });
              this.getInvoicesList("cancel");
            }}
          >
            <h5>Cancelled Invoices <b>({this.state.countList.cancelCount})</b>{" "}</h5>
          </div>
        </div>

        <Formik
          initialValues={this.state.formResponseData}
          enableReinitialize
          onChange={({ nextValues }) => {
            console.log(nextValues, "asdasdasd");
          }}
          onReset={(values, actions) => {
            this.setState({
              //formResponseData: data,
              formResponseData: this.state.formResponseData,
            });
          }}
          onSubmit={(values, actions) => {
            var self = this;

            
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            handleReset,

            isSubmitting,
          }) => (
            <Form autoComplete="off">
              <>
                <ClearButton
                  className="download_button m-0 justify-content-end"
                  type="button"
                  onClick={() => {
                    this.downlodFile();
                  }}
                >
                  Download
                </ClearButton>
                <div
                  className="tableContainer p-0"
                  style={{ overflowX: "auto" }}
                >
                  {this.state.tableTOShow == "RENT" && (
                    <table className="table tableSimple tableSimpleWithNoFlex">
                      <thead>
                        <tr>
                          {this.state.selectedStatus != "cancel" &&
                            this.state.selectedStatus != "apply" && (
                              <th scope="col">Select</th>
                            )}
                          <th scope="col">Sr. No.</th>
                          <th scope="col">Lease Id</th>
                          <th scope="col">Asset Name</th>
                          <th scope="col">Sub Asset Name</th>
                          <th scope="col">Tower</th>
                          <th scope="col" colSpan="5">
                            Floor
                          </th>
                          <th scope="col">Unit No.</th>
                          <th scope="col">GLA</th>
                          <th scope="col">Brand Name</th>
                          <th scope="col">Occupier Name</th>
                          <th scope="col">Invoice Period</th>

                          <th scope="col">Charge Logic</th>
                          <th scope="col">Charge Rate</th>
                          <th scope="col">Invoice Number</th>
                          <th scope="col">Charge Base Amount</th>
                          <th scope="col">GST Rate</th>
                          <th scope="col">GST Amount</th>
                          <th scope="col">Gross Amount</th>
                          <th scope="col">TDS Rate</th>
                          <th scope="col">TDS Amount</th>
                          <th scope="col">NET Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.formResponseData.length > 0 &&
                          this.state.formResponseData.map(
                            (anObjectMapped, index) => {
                              return (
                                <tr>
                                  {this.state.selectedStatus != "cancel" &&
                                    this.state.selectedStatus != "apply" && (
                                      <td>
                                        {/* <Field type="checkbox" name={anObjectMapped.lease_id+"_"+anObjectMapped.type_str}  /> */}
                                        <Checkbox
                                          key={index}
                                          type="checkbox"
                                          name={anObjectMapped.lease_id}
                                          id={anObjectMapped.lease_id}
                                          handleClick={this.handleClick}
                                          attr={anObjectMapped.typeOfData}
                                          occupierId={
                                            anObjectMapped.occupierId
                                          }
                                          netAmt={anObjectMapped.net_amt}
                                          invoiceId={
                                            anObjectMapped.invoice_id
                                          }
                                          amtBeforeTax={
                                            anObjectMapped.net_charge_amount
                                          }
                                        //isChecked={isCheck.includes(id)}
                                        />
                                        {/* <input key={anObjectMapped.lease_id} type="checkbox" name="invoiceCheckbox"  value={anObjectMapped.lease_id} onChange={this.handleChangeChk(anObjectMapped.lease_id)}  /> */}
                                      </td>
                                    )}
                                  <td>{index + 1}</td>
                                  <td>{anObjectMapped.leaseName}</td>
                                  <td>{anObjectMapped.assetName}</td>
                                  <td>{anObjectMapped.subAssetName}</td>
                                  <td>{anObjectMapped.tower}</td>
                                  <td colSpan="5">{anObjectMapped.floor}</td>
                                  <td>{anObjectMapped.unit}</td>
                                  <td>{anObjectMapped.grossLeasebleArea}</td>
                                  <td>{anObjectMapped.brandName}</td>
                                  <td>{anObjectMapped.occupierName}</td>
                                  <td>{anObjectMapped.month}</td>

                                  <td>{anObjectMapped.typeOfData}</td>
                                  <td>{anObjectMapped.mg_rate}</td>
                                  <td>{anObjectMapped.invoice_number}</td>
                                  <td>{anObjectMapped.net_charge_amount}</td>
                                  <td>{anObjectMapped.gst_rate}</td>
                                  <td>{anObjectMapped.gst_amt}</td>
                                  <td>{anObjectMapped.gross_amt}</td>
                                  <td>{anObjectMapped.tds_rate}</td>
                                  <td>{anObjectMapped.tds_amt}</td>
                                  <td>
                                    <td>{anObjectMapped.net_amt}</td>
                                  </td>
                                </tr>
                              );
                            }
                          )}
                      </tbody>
                    </table>
                  )}
                  <div className="" style={{ 'width': "25%" }}>
                    {this.state.formResponseData.length > 0 &&
                      this.state.selectedStatus == "generate" && (
                        <div className="button_group">
                          <button type="button" className="add_button" onClick={this.generateInvoice}>
                            Generate
                          </button>
                        </div>
                      )}

                    {this.state.formResponseData.length > 0 &&
                      this.state.selectedStatus == "draft" && (
                        <div className="button_group">
                          <button type="button" className="add_button" onClick={this.approveInvoice}>
                            Approve
                          </button>
                          <button type="button" className="delete_button" onClick={this.rejectInvoice}>
                            Reject
                          </button>
                        </div>
                      )}

                    {this.state.formResponseData.length > 0 &&
                      this.state.selectedStatus == "approve" && (
                        <div className="button_group">
                          <button type="button" className="add_button" onClick={this.applyInvoice}>
                            Apply
                          </button>
                          <button type="button" className="reset_button" onClick={this.cancelInvoice}>
                            Cancel
                          </button>
                        </div>
                      )}
                  </div>
                </div>
                {/* </div> */}
              </>
            </Form>
          )}
        </Formik>
      </>
    );
  }
}

export default withRouter(LeaseExpiryReport);
